import React from 'react';
import './ConversationInfo.css';
//import clientIcon from '../../../assets/clientIcon.png';
import whatsapp from '../../../assets/whatsapp.png';
import sms from '../../../assets/sms.png';
import messenger from '../../../assets/messenger.png';
import mail from '../../../assets/mail.png'
import companyIcon from '../../../assets/home.png'
import instagram from '../../../assets/instagram.png'
import leadIcon from '../../../assets/lead3.jpg'
import instagram_direct from '../../../assets/instagram_direct.png'
import facebook from '../../../assets/facebook.png'
import youtube from '../../../assets/youtubeIcon.png'
import webchat from '../../../assets/webchaticon.png'

const ConversationInfo = (props) => {
    let info = null
    let icon = null
    if (props.selectedChannel === 'whatsapp') {
        icon = whatsapp
    }
    else if (props.selectedChannel === 'sms') {
        icon = sms
    }
    else if (props.selectedChannel === 'messenger') {
        icon = messenger
    }
    else if (props.selectedChannel === 'mail') {
        icon = mail
    }
    else if (props.selectedChannel === 'company') {
        icon = companyIcon
    }
    else if (props.selectedChannel === 'instagram') {
        icon = instagram_direct
    }
    else if (props.selectedChannel === 'facebook') {
        icon = facebook
    }
    else if (props.selectedChannel === 'ig_media') {
        icon = instagram
    }
    else if (props.selectedChannel === 'lead') {
        icon = leadIcon
    }
    else if (props.selectedChannel === 'youtube') {
        icon = youtube
    }
    else if (props.selectedChannel === 'webchat') {
        icon = webchat
    }
    if (props.chatSelected && props.selectedChannel) {
        
        const clientId = props.chatSelected.replace('+972', '0')
        let contactName = clientId

        if (props.selectedConv?.crmId && typeof props.selectedConv.crmId === 'object' && props.selectedConv.crmId.name) {//?.crmId?.name
            contactName = props.selectedConv.crmId.name
        }
        else if (props.selectedConv?.contactId && typeof props.selectedConv.contactId === 'object') {
            contactName = props.selectedConv.contactId.fullName
        }
        else if (props.selectedConv?.displayName) {
            contactName = props.selectedConv.displayName
        }

        //add additional number
        if (props.selectedChannel === 'whatsapp' || props.selectedChannel === 'sms') {
            contactName = clientId + '-' + contactName;
        }
        if(props.selectedChannel === 'lead'){
            contactName = `${props.selectedConv?.clientName} ${props.selectedConv?.displayName}`
        }

        info = <h5 className='convinfoProp'>
            <i className="fas fa-home fa-lg myIconConversationInfo" onClick={() => props.changeWindowToShow(1)}>
            {/* </i><img alt='Cant load img' src={icon} className='userIconConv' />{contactName} */}
            </i><img alt='Cant load img' src={icon} className={props.selectedChannel === 'webchat' ? 'userIconConvWithoutBorderRadius' : 'userIconConv'} />{contactName}

        </h5>
    }
    return (
        <div className={'row inChatTopRowCenter'}>
            <div className='col-12'>
                <div className='ConversetionSection'>

                    {info}
                </div>
            </div>
        </div>
    );
};
export default ConversationInfo;